import React from "react";
import Header from "../Components/Common/Header";
import ProblemSolvingArticle from "../Components/Pages/ProblemSolving/ProblemSolvingArticle";
import Footer from "../Components/Common/Footer";

export default function ProblemSolving() {
  return (
    <>
      <Header label="article" />
      <ProblemSolvingArticle />
      <Footer label="article" />
    </>
  );
};
